import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";

import { useGetProjectQuery } from "../../../app/services/projects";
import { useGetCurrentUserQuery } from "../../../app/accounts/authuser";
import { useProjectFieldSync } from "../../../hooks/useProjectFieldSync";
import GuideImage from "../../../components/guide-image/GuideImage";
import TitleBlock from "../../../components/block/TitleBlock";
import Input from "../../../components/form-item/Input";
import Autofill from "../../../components/autofill/AutoFill";
import StatusIndicator from "../../../components/status-indicator/StatusIndicator";
import SvgLoadingAnimation from "../../../components/loading/index";

const ProjectCodeName = () => {
  const { projectId } = useParams();
  const { data: currentUserData } = useGetCurrentUserQuery();
  const { data: projectData, isLoading } = useGetProjectQuery(
    { project_id: projectId },
    { skip: !projectId || !currentUserData }
  );
  const { updateStatus, debouncedSave } = useProjectFieldSync(projectId);

  const [codeName, setCodeName] = useState("");
  const isComposingRef = useRef(false);
  const initializedRef = useRef(false);

  useEffect(() => {
    if (!initializedRef.current && projectData?.data?.project) {
      setCodeName(projectData.data.project.code_name || "");
      initializedRef.current = true;
    }
  }, [projectData]);

  const handleSelectContent = (content) => {
    setCodeName(content);
    debouncedSave({ code_name: content });
  };

  const handleChange = (e) => {
    const value = e.target.value;
    setCodeName(value);
    if (!isComposingRef.current) {
      debouncedSave({ code_name: value });
    }
  };

  const handleCompositionStart = () => { isComposingRef.current = true; };
  const handleCompositionEnd = (e) => {
    isComposingRef.current = false;
    const value = e.target.value;
    setCodeName(value);
    debouncedSave({ code_name: value });
  };

  if (isLoading) return <SvgLoadingAnimation />;

  return (
    <div className="u-col u-w100 u-gap16">
      <TitleBlock
        title="コードネーム"
        description="プロジェクトのコードネームを設定できます。関係者だけで使う秘密の呼び名として、プロジェクトを安全に識別するために使います。"
      />
      <GuideImage name="project_codename" />
      <Autofill
        group="codeName"
        nowrap={false}
        onSelectContent={handleSelectContent}
      />
      <Input
        type="text"
        label="コードネーム"
        option="required"
        placeholder="Apollo"
        width="100%"
        maxlength={255}
        name="code_name"
        value={codeName}
        onChange={handleChange}
        onCompositionStart={handleCompositionStart}
        onCompositionEnd={handleCompositionEnd}
      />
      <StatusIndicator status={updateStatus} />
    </div>
  );
};

export default ProjectCodeName;
